var _g, _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessFullModalTopImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 219,
    viewBox: "0 0 219 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4389_24463)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 109.5,
    r: 87.5,
    fill: "#3BBD3B",
    fillOpacity: 0.3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 110,
    r: 83,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.482 89.3669C144.813 87.6227 146.211 85.7953 147.66 83.8965C159.061 98.3651 161.178 126.703 140.851 145.47C122.084 162.796 92.6205 162.063 74.678 143.835C56.624 125.494 56.4373 96.2502 74.149 77.7015C92.3878 58.6063 121.245 59.2174 137.754 73.1765C136.125 74.6256 134.491 76.0785 132.562 77.7954C122.823 70.7273 111.34 68.3494 98.9934 71.2191C89.6081 73.4004 81.9396 78.5531 76.1749 86.3203C64.3149 102.299 65.6016 123.905 79.1863 138.228C92.773 152.551 114.257 154.992 130.898 144.273C144.59 135.453 156.528 113.93 143.482 89.3669Z",
    fill: "#5edd5b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.163 114.161C106.841 108.648 112.32 103.474 117.634 98.1354C128.274 87.4496 138.822 76.673 149.416 65.9413C150.075 65.2745 150.739 64.5891 151.501 64.0562C152.716 63.2066 153.995 63.3875 155.09 64.3007C156.307 65.3126 156.66 66.6599 155.988 68.1129C155.65 68.8472 155.073 69.4778 154.571 70.1299C137.924 91.8025 121.273 113.472 104.624 135.14C104.337 135.514 104.067 135.902 103.756 136.256C101.485 138.848 99.4559 138.791 97.5102 135.873C94.2455 130.973 91.106 125.989 87.9156 121.039C85.5553 117.375 83.1237 113.756 80.8593 110.032C78.8168 106.674 79.7065 102.968 82.8157 101.105C85.3236 99.602 87.5636 99.9129 89.7802 102.221C93.2062 105.79 96.5686 109.42 99.9663 113.018C100.362 113.439 100.803 113.819 101.163 114.161Z",
    fill: "#5edd5b"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4389_24463",
    x: 0,
    y: 0,
    width: 219,
    height: 219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_4389_24463"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFullModalTopImg);
export default __webpack_public_path__ + "static/media/SuccessFullModalTopImg.c0dfbd40e924ebb8d5e959b035e9ec9c.svg";
export { ForwardRef as ReactComponent };